import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EnumsService {

  constructor() { }
}

export enum StudentType {
  local = 1,
  sadc = 2,
  international = 3
}